import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

const headers = new HttpHeaders({ 'responseType': 'arraybuffer' });

@Injectable({
  providedIn: 'root'
})
export class FulfillService {
  getAvailablePrintConfigs() {
    return this.httpClient.get<any>('/api/Fulfill/getAvailablePrintConfigs');
  }
  constructor(private httpClient: HttpClient) { }

  getPrintifyFulfillConfigs() {
    return this.httpClient.get<any>('/api/Fulfill/GetPrintifyFulfillConfigs');
  }

  downloadExportFileForPrintify(exportPrintify: any, saleRecords: any[]) {    
    var selectedSaleRecordIds = [];
    for (var i = 0; i < saleRecords.length; i++) {
      if (saleRecords[i].isSelected == true) {
        selectedSaleRecordIds.push(saleRecords[i].orderItemId.replace(',',';'));
      }
    }
    exportPrintify.selectedOrderItemIds = selectedSaleRecordIds;
    let params = new URLSearchParams();
    for (let key in exportPrintify) {
      params.set(key, exportPrintify[key])
    }

    return this.httpClient.get(
      '/api/Fulfill/downloadExportFileForPrintify?' + params.toString(),
      { responseType: 'arraybuffer', headers: headers }
    );
  }

  downloadExportFileForFlashship(saleRecords: any[]) {    
    var selectedSaleRecordIds = [];
    var exportPrintify = {selectedOrderItemIds: []};
    for (var i = 0; i < saleRecords.length; i++) {
      if (saleRecords[i].isSelected == true) {
        selectedSaleRecordIds.push(saleRecords[i].orderItemId.replace(',',';'));
      }
    }
    exportPrintify.selectedOrderItemIds = selectedSaleRecordIds;
    let params = new URLSearchParams();
    for (let key in exportPrintify) {
      params.set(key, exportPrintify[key])
    }

    return this.httpClient.get(
      '/api/Fulfill/downloadExportFileForFlashship?' + params.toString(),
      { responseType: 'arraybuffer', headers: headers }
    );
  }

  downloadExportFileForBestPrintCare(saleRecords: any[]) {    
    var selectedSaleRecordIds = [];
    var exportPrintify = {selectedOrderItemIds: []};
    for (var i = 0; i < saleRecords.length; i++) {
      if (saleRecords[i].isSelected == true) {
        selectedSaleRecordIds.push(saleRecords[i].orderItemId.replace(',',';'));
      }
    }
    exportPrintify.selectedOrderItemIds = selectedSaleRecordIds;
    let params = new URLSearchParams();
    for (let key in exportPrintify) {
      params.set(key, exportPrintify[key])
    }

    return this.httpClient.get(
      '/api/Fulfill/downloadExportFileForBestPrintCare?' + params.toString(),
      { responseType: 'arraybuffer', headers: headers }
    );
  }

  downloadExportFileForMerchize(saleRecords: any[]) {
    var selectedSaleRecordIds = [];
    var exportPrintify = {selectedOrderItemIds: []};
    for (var i = 0; i < saleRecords.length; i++) {
      if (saleRecords[i].isSelected == true) {
        selectedSaleRecordIds.push(saleRecords[i].orderItemId.replace(',',';'));
      }
    }
    exportPrintify.selectedOrderItemIds = selectedSaleRecordIds;
    let params = new URLSearchParams();
    for (let key in exportPrintify) {
      params.set(key, exportPrintify[key])
    }

    return this.httpClient.get(
      '/api/Fulfill/downloadExportFileForMerchize?' + params.toString(),
      { responseType: 'arraybuffer', headers: headers }
    );
  }

  getBlueprints() {
    return this.httpClient.get<any>('/api/Fulfill/GetPrintifyBluePrints');
  }

  getPrintifyProviders() {
    return this.httpClient.get<any>('/api/Fulfill/getPrintifyProviders');
  }

  sendOrderFlashshipApi(saleRecords: any[]) {
    var params = this.selectedSaleRecordsToUrlParams(saleRecords);
    return this.httpClient.post(
      '/api/Fulfill/sendOrderFlashshipApi?' + params.toString(),
      {});
  }

  sendOrderBestPrintCareApi(saleRecords: any[]) {
    var params = this.selectedSaleRecordsToUrlParams(saleRecords);
    return this.httpClient.post(
      '/api/Fulfill/sendOrderBestPrintCareApi?' + params.toString(),
      {});
  }

  sendOrderIsoApi(saleRecords: any[]) {
    var params = this.selectedSaleRecordsToUrlParams(saleRecords);
    return this.httpClient.post(
      '/api/Fulfill/SendOrderIsoApi?' + params.toString(),
      {});
  }

  sendOrderPrintpossApi(saleRecords: any[]) {
    var params = this.selectedSaleRecordsToUrlParams(saleRecords);
    return this.httpClient.post(
      '/api/Fulfill/SendOrderPrintpossApi?' + params.toString(),
      {});
  }

  downloadExportFileForGke(saleRecords: any[]) {
    var selectedSaleRecordIds = [];
    var exportPrintify = { selectedOrderItemIds: [] };
    for (var i = 0; i < saleRecords.length; i++) {
      if (saleRecords[i].isSelected == true) {
        selectedSaleRecordIds.push(saleRecords[i].orderItemId.replace(',', ';'));
      }
    }
    exportPrintify.selectedOrderItemIds = selectedSaleRecordIds;
    let params = new URLSearchParams();
    for (let key in exportPrintify) {
      params.set(key, exportPrintify[key])
    }

    return this.httpClient.get(
      '/api/Fulfill/downloadExportFileForGke?' + params.toString(),
      { responseType: 'arraybuffer', headers: headers }
    );

  }

  sendOrderToMonkeyKingPrintApi(saleRecords: any[]) {
    var params = this.selectedSaleRecordsToUrlParams(saleRecords);
    return this.httpClient.post(
      '/api/Fulfill/sendOrderToMonkeyKingPrintApi?' + params.toString(),
      {});
  }

  selectedSaleRecordsToUrlParams(saleRecords: any[]) {
    var selectedSaleRecordIds = [];
    for (var i = 0; i < saleRecords.length; i++) {
      if (saleRecords[i].isSelected == true) {
        selectedSaleRecordIds.push(saleRecords[i].orderItemId.replace(',', ';'));
      }
    }
    var exportModel = { selectedOrderItemIds: [] };
    exportModel.selectedOrderItemIds = selectedSaleRecordIds;
    let params = new URLSearchParams();
    for (let key in exportModel) {
      params.set(key, exportModel[key]);
    }
    return params;
  }

  getAvailableOnosConfigs() {
    return this.httpClient.get<any>('/api/Fulfill/getOnosConfigs');
  }

  sendOrderOnosApi(saleRecords: any[]) {
    var params = this.selectedSaleRecordsToUrlParams(saleRecords);
    return this.httpClient.post(
      '/api/Fulfill/SendOrderOnosApi?' + params.toString(),
      {});

  }

  sendOrderGearmentApi(saleRecords: any[]) {
    var params = this.selectedSaleRecordsToUrlParams(saleRecords);
    return this.httpClient.post(
      '/api/Fulfill/sendOrderGearmentApi?' + params.toString(),
      {});

  }

  sendOrderZenithApi(saleRecords: any[]) {
    var params = this.selectedSaleRecordsToUrlParams(saleRecords);
    return this.httpClient.post(
      '/api/Fulfill/sendOrderZenithApi?' + params.toString(),
      {});

  }

  sendOrderAtdApi(saleRecords: any[]) {
    var params = this.selectedSaleRecordsToUrlParams(saleRecords);
    return this.httpClient.post(
      '/api/Fulfill/sendOrderAtdApi?' + params.toString(),
      {});

  }

  sendOrderHdStickerApi(saleRecords: any[]) {
    var params = this.selectedSaleRecordsToUrlParams(saleRecords);
    return this.httpClient.post(
      '/api/Fulfill/sendOrderToHdStickerApi?' + params.toString(),
      {});

  }

  sendOrderTeroApi(saleRecords: any[]) {
    var params = this.selectedSaleRecordsToUrlParams(saleRecords);
    return this.httpClient.post(
      '/api/Fulfill/sendOrderToTeroApi?' + params.toString(),
      {});
  }

  // VTP
  getVtpMerchandise(filter: string = '', take: number = 20, skip: number = 0) {
    return this.httpClient.get<any>(`/api/Fulfill/GetVtpMerchandise?filter=${encodeURIComponent(filter || '')}&take=${take}&skip=${skip}`);
  }

  getVtpLineShipPrice(request: any) {
    return this.httpClient.post<any>(`/api/Fulfill/GetVtpLineShipPrice`, request);
  }

  sendOrderVtpApi(saleRecords: any[]) {
    var params = this.selectedSaleRecordsToUrlParams(saleRecords);
    return this.httpClient.post(
      '/api/Fulfill/SendOrderVtpApi?' + params.toString(),
      {});
  }

  getGearmentProducts() {
    return this.httpClient.get<any>('/api/Fulfill/GetGearmentProducts');
  }

  getTiktokProductDimension(merchantId: string, tiktokProductId: string) {
    return this.httpClient.get<any>(`/api/Fulfill/GetTiktokProductDimension?merchantId=${merchantId}&tiktokProductId=${tiktokProductId}`);
  }

  getHoGoToPodProducts() {
    return this.httpClient.get<any>('/api/Fulfill/GetHoGoToPodProducts');
  }

  getPrintpossProducts() {
    return this.httpClient.get<any>('/api/Fulfill/GetPrintpossProducts');
  }

  sendOrderHoGoToPodApi(saleRecords: any[]) {
    var params = this.selectedSaleRecordsToUrlParams(saleRecords);
    return this.httpClient.post(
      '/api/Fulfill/sendOrderHoGoToPodApi?' + params.toString(),
      {});
  }

  sendOrderPrintifyApi(saleRecords: any[]) {
    var params = this.selectedSaleRecordsToUrlParams(saleRecords);
    return this.httpClient.post(
      '/api/Fulfill/SendOrderPrintifyApi?' + params.toString(),
      {});
  }
}
